<template>
  <div>
    <div class="page">
      <el-divider></el-divider>
      <SiruiSearch
        :query="query"
        :columns="formColumn"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchTrigger"
      ></SiruiSearch>
      <!-- <el-row class="page-row">
        <el-button type="primary" @click="search" :loading="load" class="search">搜索</el-button>
        <el-button type="primary" @click="resetBtnClick" class="reset">重置</el-button>
        <el-button type="primary" @click="search" :loading="load" class="search">导出</el-button>
      </el-row> -->
      <!-- <el-button type="primary" @click="auditClick" class="audit">审核</el-button> -->

      <div class="main-content">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          :loading="load"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="false"
          :columns="columnListDefault"
          @chooseClick="chooseClick"
          @dblclickEvent="dblclickEvent"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          @handleSelectionChange="handleSelectionChange"
        >
          <vxe-table-column
            v-for="(item, index) in columnListDefault"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title ? $t(item.title) : null"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template v-slot="{ row }">
              <template v-if="item.field === 'auditStatus'">{{
                getAuditStatus(row.auditStatus)
              }}</template>
              <template v-else-if="item.field === 'meterType'">{{
                getMeterType(row.meterType)
              }}</template>
              <template v-else-if="item.field === 'smartFlag'">{{
                row.smartFlag == '0' ? '否' : '是'
              }}</template>
              <template v-else-if="item.field === 'applicationNo'">
                <a @click="jumpToMeterDetail(row)" href="#" style="color: blue; cursor: pointer">{{
                  row[item.field]
                }}</a>
              </template>
              <template v-else>{{ row[item.field] }}</template>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
    </div>
  </div>
</template>
<script>
  import MeterAPI from '@/api/property/meterManagement';
  import { indexColumn, tableColumn } from './columns/columns.js';
  export default {
    name: 'WaterMeterAudit',
    components: {},
    computed: {
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      formColumn() {
        return indexColumn(this);
      },
    },
    data() {
      return {
        columnListDefault: [],
        menuButtonList: [],
        tableData: [], // 表格数据
        query: { waterCompanyNo: null, meterType: null, meterNumber: null, auditStatus: null },
        exportQuery: {},
        load: false,
        companyList: [],
        multipleSelection: [],
      };
    },
    mounted() {
      this.query.waterCompanyNo = this.userInfo.companyCode;
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.setPageSize(10);
      this.columnListDefault = tableColumn();
      this.getAuditList();
      this.getCompany();
      this.getButtonList();
    },
    methods: {
      chooseClick(value) {
        if (value == 'audit') {
          this.auditClick();
        } else {
          this[value]();
        }
      },

      //双击事件
      dblclickEvent({ row }) {
        this.$router.push({
          path: '/property/waterAuditDetail',
          query: { type: 'detail', id: row.id },
        });
      },
      jumpToMeterDetail(row) {
        this.$router.push({
          path: '/property/waterAuditDetail',
          query: { type: 'detail', id: row.id },
        });
      },

      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      // 重置按钮
      resetBtnClick() {
        console.log('重置');
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.query.waterCompanyNo = this.userInfo.companyCode;
        this.getAuditList();
      },
      // 搜索按钮
      searchTrigger() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getAuditList();
      },
      // 审核状态
      getAuditStatus(status) {
        const auditStatus = {
          1: '待审核',
          2: '审核通过',
        };
        return auditStatus[status] || '审核驳回';
      },
      getMeterType(type) {
        const meterType = {
          1: '总表',
          2: '单元水表',
          3: '楼层水表',
        };
        return meterType[type] || '房号水表';
      },
      handleSizeChange() {
        this.getAuditList();
      },
      handleCurrentChange() {
        this.getAuditList();
      },
      // 选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row;
        console.log(row);
      },
      //获取列表数据
      async getAuditList() {
        this.load = true;
        let params = {
          ...this.query,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
        };
        const { data } = await this.$axios.post(MeterAPI.WATER_METER_APPROVAL_LIST, params);
        this.load = false;
        if (data.code == 0) {
          this.tableData = data.data.records;
          var str = JSON.stringify(this.query);
          this.exportQuery = JSON.parse(str);
          this.$refs.siruiTable.setPageTotal(data.data.total);
          this.$refs.siruiTable.setPageSize(data.data.size);
        }
      },
      // 导出
      async export() {
        if (this.tableData.length == 0) {
          this.$message.error('暂无数据');
          return;
        }
        this.multipleSelection = this.$refs.siruiTable.getCheckboxRecords();
        var params = {};
        if (this.multipleSelection.length > 0) {
          params.ids = this.multipleSelection.map((item) => item.id);
          params.waterCompanyNo = this.exportQuery.waterCompanyNo;
        } else {
          const { pageNum, pageSize } = this.$refs.siruiTable.page;
          this.exportQuery.pageNum = pageNum;
          this.exportQuery.pageSize = pageSize;
          params = this.exportQuery;
        }
        const { data } = await this.$axios.post(MeterAPI.WATER_METER_ADUIT_EXPORT, params);
        if (data.code === 0) {
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'success',
          });
          window.location.href = data.data;
        } else {
          this.$alert(data.msg);
        }
      },
      //获取公司信息
      async getCompany() {
        const { data } = await this.$axios.post(MeterAPI.GET_LIST_PERSON, {
          id: this.userInfo.userCode,
        });
        if (data.code == 0) {
          this.companyList = data.data.personCompanyInfo;
        }
      },
      ///审核
      auditClick() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请选择数据');
        } else if (this.multipleSelection.length > 1) {
          this.$message.warning('请选择一条数据');
        } else {
          if (this.multipleSelection[0].auditStatus != '1') {
            this.$message.warning('该状态的数据不支持审核，请核实');
          } else {
            this.$router.push({
              path: '/property/waterAuditDetail',
              query: { type: 'approval', id: this.multipleSelection[0].id },
            });
            this.$refs.siruiTable.clearCheckboxReserve();
          }
        }
      },
    },
  };
</script>
<style scoped lang="scss">
  .page {
    background-color: white;
    margin-top: 0px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 20px;
    height: 100%;
    top: 0;
    .page-row {
      text-align: right;
      margin-right: 20px;
      margin-bottom: 10px;
    }
    .el-divider--horizontal {
      display: block;
      height: 0.5px;
      width: 100%;
      margin: 1px 0;
    }
    .search {
      border-width: 0px;
      width: 55px;
      height: 28px;
      background-color: rgba(66, 133, 244, 1);
      box-sizing: border-box;
      border-width: 1px;
      border-style: solid;
      text-align: center;
      border-color: rgba(66, 133, 244, 1);
      border-radius: 4px;
      box-shadow: none;
      color: #ffffff;
      padding: 0 0 0 0;
    }
    .reset {
      border-width: 0px;
      width: 51px;
      height: 28px;
      text-align: center;
      background: inherit;
      background-color: rgba(235, 243, 254, 1);
      box-sizing: border-box;
      border-width: 1px;
      border-style: solid;
      border-color: rgba(205, 217, 230, 1);
      border-radius: 4px;
      box-shadow: none;
      color: #768696;
      padding: 0 0 0 0;
    }
    .audit {
      width: 80px;
      height: 28px;
      font-size: 16px;
      text-align: center;
      background-color: rgba(66, 133, 244, 1);
      border-style: solid;
      border-color: rgba(66, 133, 244, 1);
      border-radius: 4px;
      color: #ffffff;
      padding: 0 0 0 0;
      margin-top: 10px;
    }
    ::v-deep .sirui-table .vxe-toolbar[data-v-3c6ed471] {
      margin-top: 0px;
    }
  }
</style>
